import { getScrollEventTarget, getScrollTop } from "@theme/scroll-container";

class BackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.scrollTarget = getScrollEventTarget();
    this.handleScroll = () => this.updateVisibility();
    this.handleClick = () => {
      const scrollContainer =
        this.scrollTarget === document
          ? document.scrollingElement
          : this.scrollTarget;
      scrollContainer?.scrollTo({ top: 0, behavior: "smooth" });
    };

    this.scrollTarget.addEventListener("scroll", this.handleScroll, {
      passive: true,
    });
    this.button?.addEventListener("click", this.handleClick);
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.scrollTarget?.removeEventListener("scroll", this.handleScroll);
    this.button?.removeEventListener("click", this.handleClick);
  }

  updateVisibility() {
    this.hidden = getScrollTop() < 300;
  }
}

if (!customElements.get("back-to-top")) {
  customElements.define("back-to-top", BackToTop);
}
